import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment-wrapper'
import sortBy from 'lodash/sortBy'
import groupBy from 'lodash/groupBy'
import reverse from 'lodash/reverse'

import LeftSidebar from 'components/Shared/Sidebar/LeftSidebar'
import CollapseLink from 'components/Shared/CollapseLink/Index'
import ReleaseList from './ReleaseList.js'

const groupByYear = (releases) => {
  const releasesSorted = reverse(sortBy(releases, r => r.date))
  const releasesGroupped = groupBy(releasesSorted, r => moment(r.date).tz('UTC').format('YYYY'))
  return releasesGroupped
}

const ReleasesListSidebar = ({ releaseNotes, selectedReleaseNoteId, onReleaseNoteClick }) => {
  const { t } = useTranslation()
  const [isSidebarVisible, setIsSidebarVisible] = useState(true)

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible)
  }

  const releasesData = groupByYear(releaseNotes)
  const releaseYears = reverse(Object.keys(releasesData))

  return (
    <LeftSidebar title={t('releaseNotesPage.sidebarHeader')} show={isSidebarVisible}>
      {releaseYears.map(year =>
        <ReleaseList
          key={year}
          releases={releasesData[year]}
          year={year}
          onReleaseNoteClick={onReleaseNoteClick}
          selectedReleaseNoteId={selectedReleaseNoteId}
        />
      )}
      <CollapseLink
        onClick={toggleSidebar}
        active={isSidebarVisible}
      />
    </LeftSidebar>
  )
}

ReleasesListSidebar.propTypes = {
  releaseNotes: PropTypes.array.isRequired,
  selectedReleaseNoteId: PropTypes.string,
  onReleaseNoteClick: PropTypes.func.isRequired,
}

export default ReleasesListSidebar
